import React from "react";
import { getLinkHref } from "../pages/linksUtils";

export default function CollectionItemLinks({ linksArray = [] }) {
    if (!linksArray || !linksArray.data ) {
        return null; 
    }

    return (
          <ul className="retro-link-list">
            {linksArray.data.map((item, index) => (
              <li className="retro-link-row" key={index}>
                    <div>
                        <p>Źródło</p>
                        {item?.Name}
                    </div>
                    <div>
                        <p>Opis</p>
                        {item?.Description}
                    </div>
                    <div>
                        <p>Adres</p>
                        <a href={getLinkHref(item?.Link)} target="_blank" rel="noopener noreferrer">
                        {item?.Link}
                        </a>
                    </div>
              </li>
            ))}
          </ul>
      );
}
